module.exports = __webpack_public_path__ + "f3e5a38ebb476f67e775ccf015b3d7df.pdf";